import userService from "../../helpers/authservice/user.service";
import notificationService from "../../services/notification.service";

    export let state ={
        users:[],
        notifications:[],
        roles:[],
        permissions:[],
        

    }
    export const actions = {
        fetch_users({commit}, payload) {
            // Extract user_type from the payload if it exists
            const user_type = payload.user_type || null;
        
            return userService.get_users(user_type).then(
                data => {
                    commit('SET_USER', data.data.data);  // Store the users data
                    return Promise.resolve(data.data);  // Return the data
                }, 
                error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);  // Handle any error
                }
            );
        },
        fetch_notifications({commit,},payload){
            return  notificationService.fetch_notifications(payload).then(
                data => {
                    // console.log(data);
                    
                    commit ('SET_NOTIFICATIONS', data.notifications.data);
                    return Promise.resolve(data.notifications);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },
        // getProfile({commit}){
        //     // TBD Get user data and use that to get  current auth user 
        //     return  userService.verifyUser().then(
        //         data => {
        //             commit ('SET_USER', data.user);
        //             return Promise.resolve(data.user);
        //         }, error => {
        //             commit('AssetsFailed');
        //             return Promise.reject(error);
        //         }
        //     );
        // },
        fetch_roles({commit}){
            return userService.get_roles().then(
                data => {
                    commit ('SET_ROLES', data.data);
                    return Promise.resolve(data.data);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },
        get_permissions({commit}){
            return userService.get_permissions().then(
                data => {
                    commit ('SET_PERMISSIONS', data.permissions);
                    return Promise.resolve(data.permissions);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },
        
    }
    export const mutations = {
       
        SET_USER(state,users){
            state.users = users
            // console.log(state.users);
        },
        SET_ROLES(state,roles){
            state.roles = roles
        },
        SET_PERMISSIONS(state,permissions){
            state.permissions = permissions
        },

        SET_NOTIFICATIONS(state,notifications){
            state.notifications = notifications
            // console.log(state.users);
        },
       
        AssetsFailed(){

        }
    }

    export const getters = {
        get_users(state){
            return state.users
        },
        get_notifications(state){
            return state.notifications
        },
        
        get_roles(state){
            return state.roles
        },

        get_permissions(state){
            return state.permissions
        },
       
        getUserById: (state) => (id) => {
            let user =  state.users.find((user) => user.id == id);
            // console.log(state.users);
            return user
          },
    }


